import strings from './strings'
import detectBrowserLanguage from "detect-browser-language";

let language = function (){

    const languages = ['nl', 'en'];
    let lang = detectBrowserLanguage().substring(0, 2);
    if (!languages.includes(lang)) {
        lang = 'en'
    }
    strings.setLanguage(lang);
    return lang;
}

export default language
